import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

import { storageKeys } from 'settings';
import { APIHandler, Image, StorageHandler, Progress, DataHandler } from 'C4';

const shareAnalytics = (name, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj.response);
      APIHandler.trackEvent(appId, '', email, 'xpopro', name, value, true).then(() => {});
    });
  });
};
export default class SubAppButton extends Component {
  constructor(props) {
    super(props);

    const { src, customName, appId } = this.props;

    let newSrc = src;
    const name = customName.length > 0 ? customName : 'Icon-180';
    if (newSrc.length === 0) {

      if (appId > 500) {
        newSrc = `https://front.travpromobile.com/${appId}/logo.png`;
      } else {
        newSrc = `https://cdn.travpromobile.com/apptool/app/${appId}/images/${name}.png`;
      }
      
    }

    this.state = {
      appId,
      pageId: 0,
      src: newSrc,
      redir: '',
    };

  }

  render() {
    const {
      src, 
    } = this.state;
    const {
      appId,
      size,
      progress: userProgress,
      name,
      type,
      chapterId,
      email,
      pageId,
      backgroundImage,
    } = this.props;
    const percentage = Math.round((userProgress.progress / userProgress.total_pages) * 100);
    const appURL = window.location.origin;

    let buttonText;
    switch (percentage) {
      case 100:
        buttonText = i18n.translate('trainingScreens.restart');
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate('trainingScreens.start');
        break;
      default:
        buttonText = i18n.translate('trainingScreens.continue');
    }

    if (type !== 'training') {
      buttonText = i18n.translate('trainingScreens.review');
    }

    return (
      <a
        className="subApp__Card"
        href={`https://academy.travpromobile.com/${type}/${appId}/${email}/${chapterId}/${pageId}/${type === 'training'}/true/?redirurl=${appURL}/main/${type}`}
        onClick={() => {
        shareAnalytics('open-training', chapterId);
        }}
      >
        <div className="subApp__Card--content">
          <img src={backgroundImage} alt="" className="subApp__Card--backgroundImage" />
          <div className="overlay gradient" />
          <img
            resize={true}
            src={src}
            className="logo"
          />
          <h4>{name.split("|").pop()}</h4>
          <button>{buttonText.split("|").pop()}</button>
        </div>
        {type === 'training' && <Progress id={`SubAppButton_${src}`} value={percentage} />}
      </a>
    );
  }
}

SubAppButton.propTypes = {
  appId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  appId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  email: PropTypes.string,
  customName: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  chapterId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  progress: PropTypes.shape({
    progress: PropTypes.number,
    last_page: PropTypes.number,
    total_pages: PropTypes.number,
    inserted_at: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
  name: PropTypes.string,
};

SubAppButton.defaultProps = {
  appId: -1,
  chapterId: -1,
  customName: '',
  src: '',
  size: { height: 150, width: 60 },
  pageId: 0,
  email: '',
  name: 'Level II Chapter',
};